import React from 'react';
import PropTypes from 'prop-types';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { connect } from 'react-redux';
import RadioButtons from 'components/RadioButtons';
import { getPhaseErrors } from '../../../../../../reducers';
import S from 'modal.scss';
import { Dialog, Button, IconButton, Switch } from 'react-toolbox';
import { updatePhase, clearValidation } from 'actionCreators/phase';
import { updatePhaseTask } from 'actionCreators';
import PhaseType from 'types/phase';
import StyledSelect from 'components/StyledSelect';

class DepartedModal extends Resetter(Validator(React.Component)) {
  DISPOSITION_OPTIONS = [
    { value: 'no_product_selected', label: 'No product selected' },
    { value: 'product_out_of_scope', label: 'Product is out of scope (Tile, Sheet Vinyl, Backsplash, Commercial)' },
    { value: 'no_service_offline', label: 'No service/offline' },
    { value: 'technical_issue', label: 'Not able to quote due to a technical issue' },
    { value: 'customer_not_ready', label: 'Customer is not ready' },
    { value: 'tech_not_trained', label: 'Tech not trained' },
    { value: 'quote_presented', label: 'Quote Presented' },
  ];

  state = {
    isSpanish: false,
    excessMaterials: this.props.excessMaterials || 'NO_EXCESS_MATERIALS',
    disposition: '',
    errors: {},
  };

  handleLanguageChange = val => this.setState({ isSpanish: val });

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  handleSubmit = () => {
    const { phase, task } = this.props;
    const excessMaterials = this.state.excessMaterials;
    const disposition = this.state.disposition;
    const isIhq = this.isIhqWorkroom();
    const isAssessment = phase.type === 'Assessment';
    const taskSlug = task.slug || (isAssessment ? 'departed_from_appointment' : 'departed');

    const updateData = isAssessment && isIhq
      ? { id: phase.id, disposition }
      : { id: phase.id, excess_materials: excessMaterials };

    this.props.updatePhase(updateData, {})
      .then(() => {
        const taskParams = isAssessment && isIhq
          ? {
            task: { status: 'complete' },
            data: { disposition },
          }
          : { task: { status: 'complete' } };

        this.props.updatePhaseTask(
          phase.id,
          taskSlug,
          taskParams,
        ).then(() => this.handleClose())
          .catch(result => this.setState({ sendError: true, errors: result.payload.errors }));
      });
  }

  handleExcessMaterialsChange = value => this.setState({ excessMaterials: value });

  handleDispositionChange = value => this.setState({ disposition: value });

  isIhqWorkroom = () => {
    const { phase } = this.props;
    return phase && phase.workroom && (phase.workroom.ihq === true || phase.workroom.ihq === 'true');
  }

  render() {
    const { active, phase } = this.props;
    const { isSpanish, disposition } = this.state;
    const isIhq = this.isIhqWorkroom();
    const isAssessment = phase.type === 'Assessment';
    const radioButtons = [
      {
        label: isSpanish ? 'No hubo exceso de materiales'
                         : 'There were no excess materials',
        value: 'NO_EXCESS_MATERIALS',
      },
      {
        label: isSpanish ? 'Cliente dispuesto a mantener el exceso de materiales'
                         : 'Customer willing to keep excess materials',
        value: 'CUSTOMER_WILLING_TO_KEEP_EXCESS',
      },
      {
        label: isSpanish ? 'El cliente debe regresar a la tienda para obtener un reembolso'
                         : 'Customer to return to store for a refund',
        value: 'CUSTOMER_RETURN_TO_STORE_FOR_REFUND',
      },
      {
        label: isSpanish ? "Regreso a la tienda: Programe la recogida de Lowe's"
                         : "Return to store: Schedule Lowe's pick-up",
        value: 'RETURN_TO_STORE_SCHEDULE_LOWES_PICKUP',
      },
    ];

    // For Assessments: show disposition if IHQ enabled, otherwise nothing (shouldn't show modal)
    // For Installations: show excess materials
    const showDisposition = isAssessment && isIhq;
    const showExcessMaterials = !isAssessment;

    return (
      <Dialog
        active={active} className={S.modal} type="fullscreen"
        onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
      >
        <IconButton
          icon="close"
          className={S.close}
          onClick={this.handleClose}
        />
        <Switch
          checked={isSpanish}
          label="¿En español?"
          onChange={this.handleLanguageChange}
        />
        {showDisposition && (
          <div>
            <h6 className={S.signatureTitle}>{isSpanish ? 'Disposición' : 'Disposition'}</h6>
            <StyledSelect
              label={isSpanish ? 'Por favor seleccione una disposición:' : 'Please select a disposition:'}
              onChange={this.handleDispositionChange}
              options={this.DISPOSITION_OPTIONS}
              value={disposition}
              placeholder={isSpanish ? 'Seleccionar disposición' : 'Select disposition'}
              required
              error={!disposition && this.state.errors && this.state.errors.disposition}
            />
          </div>
        )}
        {showExcessMaterials && (
          <div>
            <h6 className={S.signatureTitle}>{isSpanish ? 'Exceso de Materiales' : 'Excess Materials'}</h6>
            <RadioButtons
              required
              onChange={this.handleExcessMaterialsChange}
              selectedValue={this.state.excessMaterials}
              radioButtons={radioButtons}
              text={isSpanish ? 'Por favor, seleccione qué se debe hacer con el exceso de material restante:'
                              : 'Please select what should be done with remaining excess materials:'}
            />
          </div>
        )}
        <Button
          label={isSpanish ? 'Enviar' : 'Submit'}
          flat inverse ripple
          className={S.submit}
          onClick={this.handleSubmit}
          disabled={showDisposition && !disposition}
        />
        <Button
          label={isSpanish ? 'Cancelar' : 'Cancel'}
          flat inverse ripple
          className={S.submit}
          onClick={this.handleClose}
        />
      </Dialog>
    );
  }
}

DepartedModal.propTypes = {
  isSpanish: PropTypes.bool,
  active: PropTypes.bool.isRequired,
  phase: PhaseType.isRequired,
  updatePhase: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
  clearValidation,
  updatePhase,
  updatePhaseTask,
})(DepartedModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/departedModal.jsx